import {requestTypes} from "./type";
import {BaseAction} from "../../actions/base";

const types = requestTypes;

const path = `iot/request`;

const base = new BaseAction(types);

export const getRequestDatas = () => (dispatch) => {
    return base.getDatas(path, dispatch);
};

export const getDeletedRequestDatas = () => (dispatch) => {
    return base.getDatas(`${path}/deleted`, dispatch);
};

export const getRequestData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}`, dispatch);
};

export const getDeletedRequestData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}/deleted`, dispatch);
};

export const addRequestData = (newData) => (dispatch) => {
    return base.addData(path, dispatch, newData);
};

export const editRequestData = (id, newData) => (dispatch) => {
    return base.editData(`${path}/${id}`, dispatch, newData);
};

export const deleteRequestData = (id) => (dispatch) => {
    return base.deleteData(`${path}/${id}`, dispatch, id);
};

export const restoreRequestData = (id) => (dispatch) => {
    return base.restoreData(`${path}/${id}/restore`, dispatch, id);
};

export const hardDeleteRequestData = (id) => (dispatch) => {
    return base.hardDeleteData(`${path}/${id}/confirmdelete`, dispatch, id);
};
